
import React, { forwardRef, useState } from "react";
import { Input } from "./Input";
import { Icon } from "../Icon";

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  error?: React.ReactNode;
  fieldClassName?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(function PasswordInput(
  props,
  ref,
) {
  const [shown, setShown] = useState(false);
  const toggle = () => setShown((v) => !v);

  return (
    <Input
      ref={ref}
      type={shown ? "text" : "password"}
      rightSlot={
        <button
          type="button"
          onClick={toggle}
          className="ds-input-toggle"
          aria-label={shown ? "Passwort verbergen" : "Passwort anzeigen"}
          tabIndex={-1}
        >
          <Icon name={shown ? "eyeOff" : "eye"} size={16} />
        </button>
      }
      {...props}
    />
  );
});
